var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeWAdu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 333,
    height: 142,
    viewBox: "0 0 333 142",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_303_6754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.7835 125.493L65.7244 134.537L90.9872 130.863L123.417 136.51L211.538 123.699V107.405L220.344 108.939L245.546 105.276L287.186 112.526L328.786 106.479V99.9165L370.959 107.261L58.3408 152.715L-68.2178 130.676L13.7835 118.754V125.493Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-68.2177 130.676L58.3372 152.711V299.962L-68.2177 277.93V130.679V130.676Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.3375 152.715L370.956 107.26V254.511L58.3375 299.965V152.715Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_303_6754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.945 69.1501V107.829L287.345 113.877V75.003L317.341 54.4441L328.945 69.1465V69.1501Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.34 54.4433L287.345 75.0022L204.065 60.5015L234.061 39.9426L317.34 54.4433Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.065 60.502L287.345 75.0027V113.876L245.705 106.626V102.668L204.065 95.4174V60.502Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.863 103.039V99.0803L220.503 106.331V110.289L178.863 103.039Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.503 106.33L178.863 99.0801L204.065 95.4171L245.705 102.667L220.503 106.33Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.705 106.625L220.504 110.288V106.33L245.705 102.667V106.625Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.945 69.1497L317.341 54.4473M328.945 107.829V69.1497V107.829ZM328.945 107.829L287.345 113.876L328.945 107.829Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.342 54.4441L287.35 75.003",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M317.34 54.4433L234.061 39.9426M234.061 39.9426L204.065 60.5015L234.061 39.9426Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.349 75.0027L204.065 60.502",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.065 95.4174V60.502",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.503 106.33L178.863 99.0801M287.348 113.876V75.0023V113.876Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.705 106.626L220.503 110.289M178.863 103.038V99.08V103.038ZM220.503 110.289L178.863 103.038L220.503 110.289ZM204.065 95.4134L178.863 99.08L204.065 95.4134Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.504 110.288V106.33M245.705 102.667V106.625V102.667ZM245.705 102.667L220.504 106.33L245.705 102.667Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M287.348 113.876L245.705 106.626",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.705 102.667L204.065 95.4171",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.91 69.0067V60.5277L234.31 39.8473L317.652 54.7372L328.82 69.0067V107.679L287.252 113.676L245.478 106.438L220.454 110.368L211.975 108.713",
    stroke: "#2A2CB1",
    strokeWidth: 1.24083
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_303_6754)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.3367 61.0777L14.0225 72.7366V75.0778L3.81873 76.5617L36.3858 60.2709L37.3367 61.0777Z",
    fill: "#B4B9DD"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.0231 72.7373L37.3373 61.0784L65.9677 85.3687V136.024L14.0231 126.98V72.7373Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3858 60.2715L3.81873 76.5623V73.4251L36.3858 57.1344L68.9529 84.7671V87.9042L65.9671 85.3686L37.3367 61.0783L36.3858 60.2715Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9525 84.7665L36.3854 57.1338L50.5548 55.0736L105.708 47.0561L90.6063 81.6185L68.9525 84.7665Z",
    fill: "#F9F9F9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9547 84.7665L90.6085 81.6186V84.7557L68.9547 87.9036V84.7665Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9532 87.9042L90.6069 84.7563L91.2301 84.8643V132.35L65.9673 136.024V85.3686L68.9532 87.9042Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.777 125.185L123.656 137.997V90.0248L169.694 62.122L211.777 75.3909V125.185Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.658 137.997L91.2273 132.349V84.8639L123.034 90.4034L123.658 90.0252V137.997Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6087 84.7557V81.6186L123.039 87.2661V90.4032L91.2318 84.8637L90.6087 84.7557Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.371 76.5402L211.776 75.3912L169.693 62.1223L170.706 61.51L218.375 76.5402H218.371Z",
    fill: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.371 73.4039V76.541L170.702 61.5109L169.69 62.1232L123.652 90.026L123.029 90.4042V87.2671L170.706 58.3738L218.375 73.4039H218.371Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5556 55.0738L73.1422 41.3835L105.709 47.0527L50.5556 55.0702V55.0738Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.708 58.3728L123.039 87.2661L90.6087 81.6185L105.711 47.0561L170.708 58.3728Z",
    fill: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3858 60.2709L3.81873 76.5617M37.3367 61.0777L14.0225 72.7366L37.3367 61.0777Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9529 87.9043L90.6067 84.7563M3.81873 76.5623L14.0225 75.0784L3.81873 76.5623Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3854 57.1344L68.9526 84.7671M68.9526 84.7671L90.6063 81.6191L68.9526 84.7671Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.81873 76.562V73.4248",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.9547 87.9037V84.7666",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9671 136.024L14.0225 126.98M3.81873 73.4251L36.3858 57.1344L3.81873 73.4251ZM65.9671 136.024L91.2298 132.35L65.9671 136.024Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9673 85.3682V136.023",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.2273 132.349L123.658 137.997M123.658 137.997L211.778 125.185L123.658 137.997Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.662 137.997V90.0251M90.6087 81.6186V84.7557V81.6186ZM91.2318 132.353V84.8637V132.353Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.5556 55.0738L73.1422 41.3835M211.777 75.3913L218.372 76.5402L211.777 75.3913ZM218.372 76.5402V73.4031V76.5402Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.036 87.2635L170.706 58.3738",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.1418 41.3835L105.709 47.0563",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.035 90.4033V87.2662M218.373 76.5402L170.704 61.51L218.373 76.5402Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.371 73.4039L170.706 58.3738",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.6087 81.6183L123.039 87.2659M211.779 75.3909L169.696 62.122L211.779 75.3909Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.661 90.025L169.698 62.1222M211.778 75.3911V125.185V75.3911ZM105.709 47.0561L170.707 58.3728L105.709 47.0561ZM37.3373 61.0777L36.3864 60.2709L37.3373 61.0777ZM36.3864 57.1338L50.5557 55.0736L36.3864 57.1338ZM50.5557 55.0736L105.709 47.0561L50.5557 55.0736ZM14.0231 72.7366V75.0777V72.7366ZM14.0231 75.0777V126.979V75.0777ZM123.657 90.025L123.034 90.4032L123.657 90.025ZM170.707 61.5099L169.695 62.1222L170.707 61.5099ZM90.6073 84.7557L91.2304 84.8637L90.6073 84.7557ZM91.2304 84.8637L123.038 90.4032L91.2304 84.8637ZM68.9535 87.9036L65.9677 85.368L68.9535 87.9036ZM65.9677 85.368L37.3373 61.0777L65.9677 85.368Z",
    stroke: "#B4B9DD",
    strokeWidth: 0.360176,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.711 47.0561L90.6087 81.6185",
    stroke: "#B4B9DD",
    strokeWidth: 0.180088,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M264.089 21.6488C264.089 21.1919 264.459 20.8215 264.916 20.8215H304.622C305.079 20.8215 305.45 21.1919 305.45 21.6488V38.6067C305.45 39.0636 305.079 39.4339 304.622 39.4339H292.276C292.102 39.4339 291.931 39.4893 291.79 39.5921L285.702 44.0196C285.397 44.2418 284.979 44.2287 284.688 43.9878L279.415 39.6238C279.267 39.5011 279.08 39.4339 278.888 39.4339H264.916C264.459 39.4339 264.089 39.0636 264.089 38.6067V21.6488Z",
    fill: "#2A2CB1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M273.671 33.9575H274.902L275.627 32.1807H278.595L279.32 33.9575H280.62L277.682 26.9891H276.61L273.671 33.9575ZM277.116 28.5674L278.128 31.0391H276.093L277.116 28.5674ZM281.661 33.9575H281.8C282.435 33.9575 283.209 33.9774 283.626 33.9774C286.277 33.9774 287.607 32.3693 287.607 30.4137C287.607 28.5773 286.485 26.9791 283.706 26.9791C283.199 26.9791 282.207 27.0089 281.79 27.0089H281.661V33.9575ZM283.686 28.1207C285.343 28.1207 286.316 29.0141 286.316 30.4137C286.316 31.8829 285.343 32.8358 283.666 32.8358C283.497 32.8358 283.219 32.8358 282.882 32.816V28.1505C283.16 28.1306 283.398 28.1207 283.686 28.1207ZM294.637 27.0089H293.426V30.8307C293.426 32.1807 292.929 32.9252 291.877 32.9252C290.676 32.9252 290.14 32.0516 290.14 30.7512V27.0089H288.919V31.0093C288.919 33.0443 290.15 34.0667 291.877 34.0667C293.336 34.0667 294.637 33.2031 294.637 31.0788V27.0089Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_6754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 333,
    height: 142,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_303_6754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150.442,
    height: 74.2863,
    fill: "white",
    transform: "translate(178.684 39.7665)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_303_6754"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 214.913,
    height: 96.9701,
    fill: "white",
    transform: "translate(3.6385 41.2071)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeWAdu);
export default __webpack_public_path__ + "static/media/home_w_adu.6f9d07e3ee5c2ed5d1da9f13fc1b014f.svg";
export { ForwardRef as ReactComponent };